import React, { useMemo } from 'react'
import { RouteProps } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import HomeTemplate, { HomeTemplateProps } from '../../templates/Home'
import { useHeader } from '../../relay/Header/useHeader'
import { useFooter } from '../../relay/Footer/useFooter'
import { selectors } from '../../redux'
import { router, routesPath } from '../../router'
import { useDeclarationForm } from '../../relay/Declaration/useDeclarationForm'

const HomePage: React.FC<RouteProps> = () => {
  const header = useHeader()
  const footer = useFooter()
  const user = useSelector(selectors.auth.user)
  const { t } = useTranslation()
  const { declarationForm, hasToOptin } = useDeclarationForm()

  const templateProps: HomeTemplateProps = useMemo(
    () => ({
      layoutProps: {
        header,
        footer,
      },
      hasToOptin,
      acceptTerms: declarationForm.acceptTerms,
      background: `${import.meta.env.BASE_URL}images/home/background.jpeg`,
      card: {
        header: {
          title: t('home.card.header.title', { name: `${user?.firstName} ${user?.lastName}` }),
        },
        innerTitle: t('home.card.inner.title'),
        button: {
          text: t('home.card.inner.button'),
          href: router(routesPath.userDeclarations),
        },
      },
    }),
    [footer, header, user, t, declarationForm, hasToOptin]
  )

  return <HomeTemplate {...templateProps} />
}

export default HomePage
